export default __webpack_public_path__ + "static/media/08c83038846f341a.87c584da105403b082d99f4fc6cfc42e.svg";